export default __webpack_public_path__ + "static/media/guide-10.7b560d20.png";